import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const Hero = () => {
  const carouselData = [
    {
      id: 1,
      title: "Bastar University Raipur ",
      // tagline: "3&4 BHKD flats based on european theme",
      image: "/aaj-home/baskar-university-raipuer.jpeg",
      status: "Ongoing",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 2,
      titleImage: "/prajkata-park-name-leaf.png",
      title: "Embassy ll, Ms Kukreja Infrastructure, Nagpur ",
      // tagline: "3BHKD park facing premium flats in abhayankar nagar",
      image: "/aaj-home/1-1.jpg",
      status: "Ongoing",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 3, title: "Nirmal Trinity Towers At Umred Road ",
      // tagline: "Classical theme based Spacious flats with garden and parking facility",
      image: "/aaj-home/nirmal-trinity.jpeg",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },

    {
      id: 4, title: "NMC Devadiya Hospital Queta Colony, Nagpur ",
      // tagline: "Enjoy The Blissful Life in the Harmony of Mother Nature",
      image: "/aaj-home/nmc-devadiya-hospital.jpeg", status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },

    {
      id: 5, title: "Vidhan Bhavan At Nava Raipur",
      // tagline: "Spacious Premium Apartments",
      image: "/aaj-home/vidhan-bhavan.jpeg",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 6, title: "Haldiram Om Tatsat (2B + G + 29)",
      // tagline: "Spacious Premium Apartments",
      image: "/aaj-home/haldiram.png",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
  ];

  const carouseMobilelData = [
    {
      id: 1,
      // titleImage: "/La-maison-gallary/la-massion-name.png",
      title: "Bastar University Raipur ",
      // tagline: "3&4 BHKD flats based on european theme",
      image: "/aaj-home/baskar-university-raipuer.jpeg", status: "Ongoing",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 2,
      titleImage: "/prajkata-park-name-leaf.png",
      title: "Embassy ll, Ms Kukreja Infrastructure ",
      // tagline: "3BHKD park facing premium flats in abhayankar nagar",
      image: "/aaj-home/embassyll-ms-kukreja-infrastructure.jpeg",
      status: "Ongoing",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 3, title: "Nirmal Trinity Towers ",
      // tagline: "Classical theme based Spacious flats with garden and parking facility",
      image: "/aaj-home/nirmal-trinity.jpeg",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },

    {
      id: 4, title: "NMC Devadiya Hospital Queta",
      // tagline: "Enjoy The Blissful Life in the Harmony of Mother Nature",
      image: "/aaj-home/nmc-devadiya-hospital.jpeg", status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },

    {
      id: 5, title: "Vidhan Bhavan",
      // tagline: "Spacious Premium Apartments",
      image: "/aaj-home/vidhan-bhavan.jpeg",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
    {
      id: 6, title: "Haldiram Om Tatsat (2B + G + 29)",
      // tagline: "Spacious Premium Apartments",
      image: "/aaj-home/haldiram.png",
      status: "Completed",
      fonts: {
        title: "Cinzel, serif",
        status: "Julee, cursive",
        tagline: "Merriweather, serif"
      }
    },
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const activeData = isMobile ? carouseMobilelData : carouselData;
  const slides = [activeData[activeData.length - 1], ...activeData, activeData[0]];
  const [currentSlide, setCurrentSlide] = useState(1);
  const [transition, setTransition] = useState(true);
  const slideRef = useRef();
  const intervalRef = useRef(null);
  const nextSlide = () => setCurrentSlide((prev) => prev + 1);
  const prevSlide = () => setCurrentSlide((prev) => prev - 1);

  // 🔹 Auto Slide with Pause on Hover
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => nextSlide(), 4000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isPaused]);

  useEffect(() => {
    if (!transition) return;
    if (currentSlide === slides.length - 1) {
      setTimeout(() => {
        setTransition(false);
        setCurrentSlide(1);
      }, 1000);
    }
    if (currentSlide === 0) {
      setTimeout(() => {
        setTransition(false);
        setCurrentSlide(slides.length - 2);
      }, 1000);
    }
  }, [currentSlide, slides.length]);

  useEffect(() => {
    if (!transition) {
      setTimeout(() => setTransition(true), 50);
    }
  }, [transition]);

  return (
    <>

      {/* HERO SECTION - RESPONSIVE FIX */}
      <section
        className="relative h-[60vh] sm:h-[80vh] md:h-screen w-full overflow-hidden pt-16"
        ref={slideRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        onTouchStart={() => setIsPaused(true)}
        onTouchEnd={() => setIsPaused(false)}
      >

        <div
          className={`flex h-full w-full ${transition ? "transition-transform duration-1000 ease-in-out" : ""}`}
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >

          {slides.map((slide, index) => (
            <div
              key={index}
              className="min-w-full w-full h-full relative overflow-hidden"
            >



              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-fill hero-image-move "
              />

              {/* DARK OVERLAY */}
              <div className="absolute inset-0 bg-black/30"></div>

              {/* CONTENT BOX */}
              {index === currentSlide && slide.title && (
                <div
                  className="
      absolute 
      bottom-4 sm:bottom-8 md:bottom-12 lg:bottom-16
      left-3 sm:left-6 md:left-10 lg:left-14
      w-[92%] sm:w-[80%] md:w-[70%] lg:w-[60%]
      max-w-[900px]
      z-30
      flex flex-col
      items-start
      space-y-2 sm:space-y-3 md:space-y-4
    "
                >

                  {slides[currentSlide].id && (
                    <Link
                      to={`/project/${slides[currentSlide].id}`}
                    >
                      <button
                        className="bg-gradient-to-r from-[#011321] to-[#03365f]
          text-white uppercase tracking-wide
          px-4 sm:px-5 md:px-6
          py-1.5 sm:py-2 md:py-3
          rounded-full shadow-lg
          text-[10px] sm:text-xs md:text-sm lg:text-base
          hover:scale-105 transition-all"
                      >
                        Explore Project
                      </button>
                    </Link>
                  )}

                  <h2
                    style={{ fontFamily: slide.fonts.title }}
                    className="
        text-xs sm:text-base md:text-xl lg:text-2xl
        font-bold uppercase
        text-white bg-black/60
        px-2 sm:px-3 md:px-4
        py-1.5 sm:py-2
        rounded-lg
        inline-block
        leading-tight
      "
                  >
                    {slide.title}
                  </h2>

                </div>
              )}


            </div>
          ))}
        </div>

        {/* LEFT ARROW */}
        <button
          onClick={prevSlide}
          className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 z-40
      p-2 sm:p-4 bg-slate-700/50 backdrop-blur-sm border border-slate-600/30
      text-white rounded-full"
        >
          <ChevronLeft className="w-5 h-5 sm:w-8 sm:h-8" />
        </button>

        {/* RIGHT ARROW */}
        <button
          onClick={nextSlide}
          className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 z-40
      p-2 sm:p-4 bg-slate-700/50 backdrop-blur-sm border border-slate-600/30
      text-white rounded-full"
        >
          <ChevronRight className="w-5 h-5 sm:w-8 sm:h-8" />
        </button>

      </section>


      {/* MOBILE BELOW OVERLAY */}
      {/* {isMobile && slides[currentSlide] && slides[currentSlide].title && (
        <div className="absolute inset-0 flex flex-col justify-end items-start z-30" ref={slideRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={() => setIsPaused(true)} // Pause on mobile touch
          onTouchEnd={() => setIsPaused(false)} >
          <div className="flex items-center justify-center gap-1   py-2 rounded-xl">

            <div className="flex flex-col items-start absolute top-80 left-4 z-40">
              <div className="flex items-center gap-2 mb-2">

                {slides[currentSlide].id && (
                  <Link
                  // to={`/project/${slides[currentSlide].id}`} 
                  >
                    <button
                      className="bg-gradient-to-r from-[#011321] to-[#03365f] 
          text-white uppercase tracking-wide px-5 py-1 
          rounded-full shadow-lg text-sm"
                    >
                      Explore Project
                    </button>
                  </Link>
                )}

              </div>

              <h2
                style={{ fontFamily: slides[currentSlide]?.fonts?.title }}
                className="text-sm font-bold uppercase text-white drop-shadow-lg text-left bg-black/50 px-1 py-2 rounded-lg"
              >
                {slides[currentSlide]?.title}
              </h2>
            </div>

          </div>
        </div>
      )} */}


    </>
  );
};

export default Hero;
